const GhanaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111484)">
      <path
        d="M0 19.9989C0 22.4454 0.440078 24.7888 1.24398 26.9554L20 27.825L38.756 26.9555C39.56 24.7888 40 22.4454 40 19.9989C40 17.5525 39.56 15.2091 38.756 13.0425L20 12.1729L1.24398 13.0424C0.440078 15.2091 0 17.5525 0 19.9989H0Z"
        fill="#FFDA44"
      />
      <path
        d="M19.9997 0C11.4004 0 4.06951 5.4275 1.24365 13.0435H38.7558C35.9298 5.4275 28.599 0 19.9997 0Z"
        fill="#D80027"
      />
      <path
        d="M38.7557 26.957H1.24365C4.06951 34.573 11.4004 40.0005 19.9997 40.0005C28.599 40.0005 35.9298 34.573 38.7557 26.957Z"
        fill="#496E2D"
      />
      <path
        d="M19.9999 13.043L21.7265 18.357H27.3146L22.7941 21.6416L24.5206 26.9559L19.9999 23.6716L15.4792 26.9559L17.2061 21.6416L12.6855 18.357H18.2734L19.9999 13.043Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111484">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default GhanaSvg;
